import React from "react";
import Link from "@mui/material/Link";
import classNames from "classnames";
import "./link.scss";

export const CustomLink = ({
  href,
  size = "large",
  bold = false,
  target,
  withIcon,
  className,
  alignIcon = "",
  color = "#2a67ff",
  ...props
}) => {
  const classes = classNames(bold ? `bold ${size}` : size, className);
  const customStyle = alignIcon
    ? { display: "flex", alignItems: "center" }
    : {};

  const handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      props.onClick && props.onClick();
    }
  };

  let linkStyle = {};
  if (alignIcon == "start") {
    linkStyle = { marginLeft: "6px" };
  } else if (alignIcon == "end") {
    linkStyle = { marginRight: "6px" };
  }

  return (
    <Link
      onKeyUp={handleKeyPress}
      {...props}
      style={{ ...props.style, ...customStyle }}
      target={target}
      href={href}
      className={classes}
      underline="none"
      color={color}
      tabIndex={0}
    >
      {alignIcon == "start" && withIcon}
      <span style={linkStyle}>{props.children}</span>
      {alignIcon == "end" && withIcon}
    </Link>
  );
};
